import { IonIcon, withIonLifeCycle } from '@ionic/react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { closeCircle } from 'ionicons/icons';
import React from 'react';
import SQLStorage from '../SQLStorage';
import '../styles/LanguagePicker.scss';
import Utilities from '../Utilities';

class LanguagePicker extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {

        return (
            <SwipeableDrawer
                anchor="bottom"
                disableBackdropTransition={false}
                open={this.props.isOpen}
                onClose={ () => { this.props.onDidDismiss(); Utilities.onDrawerHide() } }
                onOpen={ () => { Utilities.onDrawerShow(); } }
                className="language-picker-modal"
            >
                <div className="swipeable-drawer-body language-picker-modal-body">
                    <div className="drag-indicator"></div>
                    <div className="content">
                        <h2>{window.ln.lnSelect}</h2>
                        <div className="drag-close-indicator" onClick={() => {
                            this.props.onDidDismiss(); Utilities.onDrawerHide() 
                        }}>
                            <IonIcon icon={closeCircle} />
                        </div>
                        { (this.props.showTheseLanguages) ?
                            <div className="selector selector-flag">
                                {/* SEARCH */}
                                <button
                                    onClick={() => { 
                                        this.props.onSelect(""); 
                                    }}
                                >
                                    <img src={require('../images/flags/xx.svg')} />
                                    {window.ln.anyLanguage}
                                </button>
                                { this.props.showTheseLanguages.map(lang => {
                                    let termLangCode = Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, lang)
                                    let termCountryCode = window.globalVars.LANGUAGES_CODES_TO_COUNTRY[termLangCode].logo;
                                    if (window.globalVars.AVAILABLE_FLAGS.indexOf(termCountryCode) === -1) {
                                        termCountryCode = "gb"
                                    }
                                    return (
                                        <button
                                            onClick={() => { 
                                                this.props.onSelect(lang); 
                                            }}
                                        >
                                            <img src={require('../images/flags/' + termCountryCode + '.svg')} />
                                            {lang}
                                        </button>
                                    )
                                }) }
                                { Object.keys(window.globalVars.LANGUAGE_CODES).map(termLangCode => {
                                    let termCountryCode = window.globalVars.LANGUAGES_CODES_TO_COUNTRY[termLangCode] ? window.globalVars.LANGUAGES_CODES_TO_COUNTRY[termLangCode].logo : null;
                                    if (window.globalVars.AVAILABLE_FLAGS.indexOf(termCountryCode) === -1) {
                                        termCountryCode = "xx"
                                    }
                                    return (
                                        <button
                                            onClick={() => { 
                                                this.props.onSelect(window.globalVars.LANGUAGE_CODES[termLangCode]); 
                                            }}
                                        >
                                            <img src={require('../images/flags/' + termCountryCode + '.svg')} />
                                            {window.globalVars.LANGUAGE_CODES[termLangCode]}
                                        </button>
                                    )
                                }) }
                            </div>
                            :
                            <div className="selector selector-flag">
                                { Object.keys(window.LANGUAGES).map(key => {
                                    let label = window.LANGUAGES[key];
                                    return (
                                        <button key={key} onClick={() => { this.props.onSelect(key); }}>
                                            <img src={require('../images/flags/' + (window.globalVars.LANGUAGES_CODES_TO_COUNTRY[key].logo) + '.svg')} />
                                            {label}
                                        </button>
                                    )
                                }) }
                            </div>
                        }
                    </div>
                </div>
            </SwipeableDrawer>
        );
    }

};


export default withIonLifeCycle(LanguagePicker);
